import { Component, OnInit, Type, DestroyRef, inject, signal } from '@angular/core';
import { UserProfile } from '@app/_models';
import { UserService } from '@app/_services';
import { environment } from '@environments/environment';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faPaperPlane, faBell, faEnvelope, faQuestionCircle, faEyeSlash, faCheckCircle, faTimesCircle, faMapMarkedAlt, faPhoneAlt, faMapPin, faMapSigns, faEye, faPhone, faBan, faSearch } from '@fortawesome/free-solid-svg-icons';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-user-profiles',
    templateUrl: './user-profiles.component.html',
    styleUrls: ['./user-profiles.component.css'],
    standalone: false
})
export class UserProfilesComponent implements OnInit {

  constructor(private userService: UserService, private _modalService: NgbModal) {

  }

loading = signal(false);
invalidMessage = signal(false);
faWhatsapp = faWhatsapp;
faPaperPlane = faPaperPlane;
faEnvelope = faEnvelope;
faQuestionCircle = faQuestionCircle;
faEyeSlash = faEyeSlash;
faCheckCircle = faCheckCircle;
faTimesCircle = faTimesCircle;
faMapMarkedAlt = faMapMarkedAlt;
faPhoneAlt = faPhoneAlt;
faMapPin = faMapPin;
faMapSigns = faMapSigns;
faEye = faEye;
faPhone = faPhone;
faBan = faBan;
faSearch = faSearch;
faBell = faBell;

userprofiles = signal<UserProfile[]>([]);

p = signal(1);

help = signal(false);

searchProfiles = signal('');
title = 'User Profiles';

private destroyRef = inject(DestroyRef);

ngOnInit(): void {
  console.log('Loading user profiles');
  this.searchProfiles.set('');

  this.userService.getAllUserProfiles()
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe({
      next: (data) => {
        this.userprofiles.set(data);
        if (!environment.production) {
          console.log('Profiles: ',data);
        }
      },
      error: () => {

      }
    });
}

toggleHelp() {
  this.help.set(!this.help());
}

openProfileDiv(username: string) {
  this.userprofiles.set(
    this.userprofiles().map(p =>
      p.username === username ? { ...p, opened: !p.opened } : p
    )
  );
}

open(name: string) {
  this._modalService.open(MODALS[name]);
  //this._modalService.open(this.messageModal);
  //this._modalService.open('exampleModalCenter');
  //this._modalService.open(this.messageModal, {size: 'lg', backdrop: 'static'})
}


sendWhatsapp(phone: string) {
  location.href = "https://wa.me/+1" + phone + "/?text=";
}

}

@Component({
    selector: 'ngbd-modal-send-message',
    template: `
  <div class="modal-header">
    <h4 class="modal-title" id="modal-title">Send User Message</h4>
    <button type="button" class="close" aria-label="Close button" aria-describedby="modal-title" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <label for="messagebox">Type message below</label>
    <textarea  class="form-control" id="messagebox" name="messagebox" rows="4">

    </textarea>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss('cancel click')">Cancel</button>
    <button type="button" ngbAutofocus class="btn btn-danger" (click)="testFunction()">Send</button>
  </div>
  `,
    standalone: false
})

export class NgbdModalSendMessage {
  constructor(public modal: NgbActiveModal) {}

  testFunction() {
    alert('Message sent.');
    this.modal.close();
  }

}

const MODALS: {[name: string]: Type<any>} = {
  autofocus: NgbdModalSendMessage
};
